export default {
  textboxPlaceholder: {
    id: 'searchbar_placeholder',
    defaultMessage: 'Looking for something (refurbished) in particular?',
  },
  resetSearchButtonAriaLabel: {
    id: 'searchbar_reset_searchbar_button_label',
    defaultMessage: 'Clear search content',
  },
  searchButtonAriaLabel: {
    id: 'searchbar_search_button_label',
    defaultMessage: 'Search',
  },
  placeholder1: {
    id: 'searchbar_placeholder_1',
    defaultMessage: 'Search air fryers',
  },
  placeholder2: {
    id: 'searchbar_placeholder_2',
    defaultMessage: 'Search vacuum robots',
  },
  placeholder3: {
    id: 'searchbar_placeholder_3',
    defaultMessage: 'Search air fryers',
  },
  placeholder4: {
    id: 'searchbar_placeholder_4',
    defaultMessage: 'Search vacuum robots',
  },
  placeholder5: {
    id: 'searchbar_placeholder_5',
    defaultMessage: 'Search smartphones',
  },
}
